<div id="TranslationControls">
  <button mat-button (click)="updateShowTranslation()" 
    matTooltip="{{showTranslation ? 'Revert to original language' : 'Translate to selected language'}}" 
    attr.aria-label="{{showTranslation ? 'Revert to original language' : 'Translate to selected language'}}"
    class="white-fg">
    <mat-icon>g_translate</mat-icon>
    {{showTranslation ? 'Show Original' : 'Translate'}}
  </button>
  <mat-divider class='style-fix' [vertical]="true"></mat-divider>
  <button mat-button [matMenuTriggerFor]="languageMenu" id="language-selector" [attr.aria-label]="ariaLabel" class="white-fg"
    matTooltip="Select Language" style="padding: 0 4px;">
    <mat-icon>language</mat-icon>
    {{language.name}}
    <mat-icon>expand_more</mat-icon>
  </button>
  <mat-menu #languageMenu="matMenu" xPosition="before">
    <button *ngFor="let language of languages; index as i" mat-menu-item aria-label="language.name"
      (click)="updateSelectedLanguage(language)" [value]="i">
      {{language.name}}
    </button>
  </mat-menu>
</div>